import { Router } from '@angular/router';
import { LoaderService } from './../loder_service/loader.service';
import { Component, OnInit } from '@angular/core';
import { DataService } from '../data.service';

@Component({
  selector: 'app-otpverify',
  templateUrl: './otpverify.component.html',
  styleUrls: ['./otpverify.component.scss'],
})
export class OtpverifyComponent implements OnInit {
  mobile_number:any;
  constructor(public router:Router, public toastService:LoaderService,public restApi:DataService) { }

  ngOnInit() {}
  submit_mobile_number(){
    //alert('its fire')
    this.toastService.showLoader('')
    if(this.mobile_number==undefined){
      this.toastService.create('Please enter a valid mobile number')
      this.toastService.hideLoader();
    }else{
      let postparams={
        mobile_number:this.mobile_number
      }
      console.log(postparams)
      this.restApi.forgotpassword(postparams).subscribe((data:any)=>{
        if(data.result==1){
          this.toastService.create('We have sent your password to your register mobile number');
          this.toastService.hideLoader();
          this.router.navigate(['/signin'])
        }else{
          this.toastService.create('Entered number does not exists in our record');
          this.toastService.hideLoader();
        }
      },(error:any)=>{
        this.toastService.hideLoader();
      })
    }
    console.log(this.mobile_number)
  }
}
